import styled from "@emotion/styled";
import { fontAngkor } from "@product/scmp-sdk";

import BackgroundMobileImage from "./background-mobile.png";
import BackgroundImage from "./background.png";
import BusImage from "./bus.png";
import PeterMobileImage from "./peter-mobile.png";
import PeterImage from "./peter.png";

export const Container = styled.div`
  position: relative;

  inline-size: 100%;
  margin-block-end: 41px;

  background-image: url(${BackgroundMobileImage.src});
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 40%;

  ${props => props.theme.breakpoints.up("tablet")} {
    block-size: 247px;
    margin-block-end: 91px;

    background-image: url(${BackgroundImage.src});
    background-size: 100% 186px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    block-size: 307.4px;
    margin-block-end: 126.6px;

    background-size: 100% 233px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    block-size: 346px;
    margin-block-end: 92px;

    background-size: 100% 271px;
  }
`;

export const Headline = styled.h1`
  padding-block: 27px 21px;

  color: #1b4191;
  font-size: 36px;
  font-family: ${fontAngkor};
  line-height: 40px;
  letter-spacing: -0.02em;
  text-align: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block: 30px 41px;

    font-size: 40px;
    line-height: 56px;
    letter-spacing: -0.8px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block-start: 48px;

    font-size: 48px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    letter-spacing: -0.96px;
  }
`;

export const Peter = styled.div`
  inline-size: 319px;
  block-size: 248px;
  margin-inline: auto;

  background-image: url(${PeterMobileImage.src});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  ${props => props.theme.breakpoints.up("tablet")} {
    position: absolute;
    inset-block-start: 18px;
    inset-inline-start: 24px;

    inline-size: 207.22px;
    block-size: 229px;

    background-image: url(${PeterImage.src});
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    inset-block-start: 26px;
    inset-inline-start: 28px;

    inline-size: 254.64px;
    block-size: 281.4px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    inset-block-start: 20px;
    inset-inline-start: 26px;

    inline-size: 295px;
    block-size: 326px;
  }
`;

export const Bus = styled.div`
  display: none;
  ${props => props.theme.breakpoints.up("tablet")} {
    position: absolute;
    inset-block-start: 30px;
    inset-inline-end: 22px;

    display: block;

    inline-size: 272.06px;
    block-size: 210.96px;

    background-image: url(${BusImage.src});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    inset-block-start: 36px;
    inset-inline-end: 24px;

    inline-size: 338.52px;
    block-size: 258.93px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    inset-block-start: 38px;
    inset-inline-end: 56px;

    inline-size: 392.17px;
    block-size: 299.96px;
  }
`;
